
import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { Center, Currency, Device, Entity, iniRawServicePoint, ServicePoint } from "@/entities";
import VisualizationToggle from "@/components/groups/group-permissions-tab/visualization-toggle/VisualizationToggle.vue";
import PCardShowHiden from "@/common/components/look/PCard/PCardShowHiden.vue";
import PButton from "@/common/components/look/PButton/PButton.vue";
import { iniRawLimit, Limit } from "@/entities/limit";
import { Getter } from "vuex-class";
import { SelectType } from "@/common/components";
import { isEqual } from "lodash";

@Component({
  components: {
    PButton,
    VisualizationToggle,
    PCardShowHiden,
  },
})
export class ServicePointForm extends Vue {
  @Prop({ required: true }) value!: ServicePoint;
  @Watch("value", { immediate: true, deep: true })
  onChangeValue(): void {
    this.servicePoint = { ...this.value };
    this.servicePoint.centerId = this.center.id;
    this.servicePoint.entityId = this.entity.id;

    this.limits = [...this.value.limits];
  }
  @Prop({ required: true }) center!: Center;
  @Prop({ required: true }) entity!: Entity;
  @Prop({ required: false }) actionName!: string;
  @Prop({ required: false }) textActionName!: string;
  @Prop({ required: false }) textCancelName!: string;
  @Prop({ required: false, default: true }) isModify!: boolean;
  @Getter("getCurrencies") getCurrencies!: Currency[];
  showModal = false;
  CASHTODAY_TYPE = "CashToday";
  servicePoint: ServicePoint = new ServicePoint({ ...iniRawServicePoint });
  validado = false;
  limits: Limit[] = [];
  servicePointType = this.CASHTODAY_TYPE;

  get isFormModified() {
    const hasServicePointChanged = !isEqual(this.servicePoint, this.value);
    const hasLimitsChanged = !isEqual(this.limits, this.value.limits);
    return hasServicePointChanged || hasLimitsChanged;
  }

  cancel(): void {
    this.$emit("cancel");
  }

  getRules(): string {
    return "required|alpha_num_non_cash_today_code";
  }

  action(action: string): void {
    this.servicePoint.limits = [...this.limits];
    this.$emit("action", this.servicePoint, this.isModify, action);
  }
}

export default ServicePointForm;
